<template>
  <div>
    <el-row>
      <el-col :span="11">
        <h3>原文</h3>
        <lined-textarea
          ref="lrc"
          v-model="lrcText"
          class="textarea"
          @scroll="handleLrcScroll"
          :readonly="true"
          :styles="{width: '500px', height: '500px', resize: 'none'}"
        ></lined-textarea>
      </el-col>
      <el-col :span="11" :offset="1">
        <h3>翻译歌词</h3>
        <lined-textarea
          ref="trans"
          v-model="transText"
          class="textarea"
          @scroll="handleTransScroll"
          :styles="{width: '500px', height: '500px', resize: 'none'}"
        ></lined-textarea>
      </el-col>
    </el-row>

    <div class="center btn">
      <el-button type="primary" @click="lyricMakeFinish">提交</el-button>
    </div>
  </div>
</template>

<script>
import commonService from '@/api/common'
import LinedTextarea from '@/components/LinedTextarea'
import Translyric from '../lyric/TransLyric.js'

export default {
  name: 'TransLyricMaker',
  components: {
    LinedTextarea,
  },
  props: {
    track: {
      type: Object,
      required: true
    },
    media: {
      type: Object,
      required: true
    },
    lrcLyricUrl: {
      type: String,
      required: true
    },
    transLyricUrl: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      lrcText: '',
      transText: '',
      submiting: false
    }
  },
  created() {
    this.getLyricText()
  },
  methods: {
    async getLyricText() {
      let lrcText
      try {
        const lrcResp = await commonService.getLyricText(this.lrcLyricUrl)
        lrcText = lrcResp.data.trim()
        this.lrcText = lrcText
      } catch (error) {
        this.$message({
          type: 'error',
          message: '获取逐行歌词异常: ' + error.message
        })
      }

      if (this.transLyricUrl) {
        try {
          const transResp = await commonService.getLyricText(this.transLyricUrl)
          const transText = transResp.data.trim()
          this.transText = transText
        } catch (error) {
          this.$message({
            type: 'error',
            message: '获取翻译歌词异常: ' + error.message
          })
        }
      } else {
        this.transText = lrcText
      }
    },
    lyricMakeFinish() {
      const lyricObj = new Translyric(this.track.trackName, this.transText)
      this.submiting = true
      this.$emit('finish', lyricObj)
    },

    handleLrcScroll(evt) {
      this.$refs.trans.$refs.textarea.scrollTop = evt.target.scrollTop
    },

    handleTransScroll(evt) {
      this.$refs.lrc.$refs.textarea.scrollTop = evt.target.scrollTop
    }
  }
}
</script>

<style scoped>
h3 {
  margin-top: 0;
}
.btn {
  margin-top: 16px;
}
</style>
